import { Link } from '@bfa/base-ui';
import { Text } from '@bfa/common-ui';
import React from 'react';
import useBusinessConfiguration from '../../../../hooks/useBusinessConfiguration';
import { SUBSCRIBED_LANDING_PAGE_EVENTS as EVENTS } from '../../../../utils/analytics/events';
var FaqSection = function (_a) {
    var content = _a.content;
    var trackEvent = useBusinessConfiguration().trackEvent;
    var handleOnClick = function () { return trackEvent(EVENTS.CLICK_ON_FAQ_LINK); };
    return (React.createElement(Text, { pb: ['3rem', '6rem'], textAlign: "center", color: "grayMedium", fontSize: "1.2rem", backgroundColor: "white" },
        React.createElement(Link, { variant: "secondary", small: true, onClick: handleOnClick, href: content === null || content === void 0 ? void 0 : content.faqLinkUrl }, content === null || content === void 0 ? void 0 : content.faqLinkText)));
};
export default FaqSection;
